import React from "react";
import { formatSecondsToMS } from "../Utils";
import { useState, useEffect, useRef } from "react";
import {
  ThemeColor,
  ALERT_TIMEOUT,
  AUTHENTICATION_URL,
  VERIFICATION_MAIL_RESEND_TIME,
} from "../Config";
import EmailVerificationCompleteView from "./EmailVerificationCompleteView";
import { useLocation } from "react-router-dom";

function EmailVerificationView() {
  //flag initialized
  const initialized = useRef(false);

  //location
  const location = useLocation();
  //user data sent from page
  const userData = location.state ?? { email_address_login: "" }; // Access the data

  //time to resend code
  //initialise with 30 seconds
  const [time, setTime] = useState(VERIFICATION_MAIL_RESEND_TIME);

  //show email verification compete screen
  const [showEmailVerificationComplete, setShowEmailVerificationComplete] =
    useState(false);

  //timer id
  const timerId = useRef();

  //email verification submit button
  const [submitClickedEmailVerification, setSubmitClickedEmailVerification] =
    useState(false);

  //email verification code
  const [emailVerificationCodeValue, setEmailVerificationCodeValue] =
    useState(0);

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //run for once at startup
  useEffect(() => {
    //check
    if (initialized.current === false) {
      //check
      emailVerificationSendEmailRequest(userData.email_address_login);
      //set
      initialized.current = true;

      console.log("Send verification email", userData.email_address_login);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //use effect handle submit action
  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (submitClickedEmailVerification === true) {
      //call endpoint
      verificationCodeVerifyRequest(userData.email_address_login);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClickedEmailVerification]);

  //email verification endpoint
  const emailVerificationSendEmailRequest = async (mail_address) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "SEND_VERIFICATION_EMAIL",
        email_address_login: mail_address,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check
        if (data.success === true) {
          //set alert state to show error
          setAlert({
            type: "success",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);

          //clear previous timer
          clearInterval(timerId.current);
          //reset
          setTime(VERIFICATION_MAIL_RESEND_TIME);
          //time for time remaiming
          timerId.current = setInterval(
            () => setTime((time) => Math.max(0, time - 1)),
            1000
          );
        } else {
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Something went wrong. Please try again later.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
      });
  };

  //verify email verification code
  const verificationCodeVerifyRequest = async (mail_address) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "VERIFY_EMAIL_CODE",
        email_address_login: mail_address,
        verification_code: emailVerificationCodeValue,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check
        if (data.success === true) {
          //show alert
          //set alert state to show error
          setAlert({
            type: "success",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);

          //show verification complete screen
          setShowEmailVerificationComplete(true);
        } else {
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);

          //show verification complete screen
          setShowEmailVerificationComplete(false);
        }

        //reset
        setSubmitClickedEmailVerification(false);

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //reset
        setSubmitClickedEmailVerification(false);
      });
  };

  //submit handler for the form
  const onSubmitEmailVerifyButton = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check
    if (emailVerificationCodeValue === null) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: "Please enter verification code and try again.",
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClickedEmailVerification(true);
  };

  //onvalue change handler for the inputs
  const onChangeEmailVerificationForm = (event) => {
    // Update the state with the new value
    setEmailVerificationCodeValue(event.target.value);
  };

  return (
    <div className="p-3">
      <div className="container col-md-4 col-md-offset-4">
        <div style={{ marginTop: "6rem" }}>
          {/* Alert for failure */}
          <div
            className={`alert alert-${alert.type} ${
              alert.visible ? "" : "d-none"
            } fade show`}
            role="alert"
            style={{ marginTop: "5rem" }}
          >
            {alert.message}
          </div>

          {/*Verify email address */}
          {showEmailVerificationComplete === false ? (
            <div className="">
              {/* title */}
              <h1 className="display-6 text-center mt-2">
                Verify email address
              </h1>

              {/* Form */}
              <div className="justify-content-center" style={{ width: "100%" }}>
                <form className="mt-5" onSubmit={onSubmitEmailVerifyButton}>
                  <div className="form-group">
                    <label className="text-muted me" htmlFor="email_code">
                      Enter code sent to your email address
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        className="form-control"
                        id="email_code"
                        aria-describedby="emailHelp"
                        placeholder="xxxx"
                        style={{ borderColor: ThemeColor, height: "60px" }}
                        value={emailVerificationCodeValue}
                        onChange={onChangeEmailVerificationForm}
                      />
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      className="btn btn-clear"
                      type="button"
                      disabled={time > 0 ? true : false}
                      onClick={(e) => {
                        //blur
                        e.target.blur();
                        //send code
                        //email verification request
                        emailVerificationSendEmailRequest(
                          userData.email_address_login
                        );
                      }}
                    >
                      <span className="text-center text-muted">
                        {formatSecondsToMS(time)}{" "}
                      </span>
                      Resend code{" "}
                    </button>
                  </div>

                  <div className="text-center justify-content-center mt-5 d-flex">
                    <div
                      className={`spinner-border text-dark me-3 align-self-center ${
                        submitClickedEmailVerification ? "" : "d-none"
                      }`}
                      role="status"
                    >
                      <span className="sr-only"></span>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-secondary fs-3 px-5"
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    >
                      Verify
                    </button>
                  </div>
                </form>
              </div>
              <p className="text-muted mt-5 text-center">
                Some features will be unavailable if you don't verify your email
                address
              </p>
            </div>
          ) : (
            <EmailVerificationCompleteView />
          )}
        </div>
      </div>
    </div>
  );
}

export default EmailVerificationView;
